import * as React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export function PlanyBrandMark() {
  const theme = useTheme();
  return (
    <Typography component="span" sx={{
      fontSize: "0.9rem",
      fontWeight: 400,
      fontFamily: "Roboto, Arial, sans-serif",
      color: theme.customChrome?.brandText || theme.palette.text.primary,
      letterSpacing: "1px",
      lineHeight: 1.2,
      whiteSpace: "nowrap",
    }}>
      <Box component="span" sx={{ display: "inline-flex", flexDirection: "column", alignItems: "flex-end", lineHeight: 1 }}>
        <Box component="span" sx={{ fontSize: "1em", fontWeight: 600 }}>
          Timely365
        </Box>
        <Box component="span" sx={{ fontSize: "0.75em", mt: "0.1em" }}>
          Booking
        </Box>
      </Box>
    </Typography>
  );
}
